import { Mesh, MeshBasicMaterial, PlaneGeometry, Vector3 } from 'three';
import { ActionControllerEventName, ResourcesManager, RoundedPlane, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class PeriodicModule extends ViewerModule {
    constructor(parentLevel) {
        super();
        this.parentLevel = parentLevel;
        this.uiObject.name = 'PeriodicModule';
        this.uiObject.position.set(0, 1, -0.5);
        this.uiObject.userData.pcPosition = this.uiObject.position.clone();
        this.uiObject.userData.pcScale = this.uiObject.scale.x;
        if (Viewer.controls.zController) {
            this.uiObject.position.set(-3, 1.07, 0);
            // @ts-ignore
            this.uiObject.scale.setScalar(1.8);
        }
        this.addObject(this.periodicTable = RoundedPlane.getRoundedPlane({
            width: 10,
            height: 10 / 1.73,
            color: 0xFFFFFF,
            r1: 0.17,
        }));
        this.periodicTable.material.map = ResourcesManager.getTexture('periodic_table');
        this.addObject(this.elementPlaceNa = new Mesh(new PlaneGeometry(0.95 / 2, 0.9 / 2), new MeshBasicMaterial({ visible: false })));
        this.elementPlaceNa.position.set(-4.447, 0.458, 0.01);
        this.addObject(this.elementPlaceCl = new Mesh(new PlaneGeometry(0.95 / 2, 0.9 / 2), new MeshBasicMaterial({ visible: false })));
        this.elementPlaceCl.position.set(3.95, 0.458, 0.01);
        this.newPosition = new Vector3(0, .17, 6.746).multiply(new Vector3(0.68, 1, 0.68));
    }
    initWaitSelectElements() {
        this.actionController.once(ActionControllerEventName.click, this.elementPlaceNa, () => this.fire('on_Na'));
        this.actionController.once(ActionControllerEventName.click, this.elementPlaceCl, () => this.fire('on_Cl'));
    }
    zoomIn() {
        this.uiObject.visible = true;
        this.oldPosition = this.uiObject.position.clone();
        this.zoomAnimation(this.uiObject, this.newPosition);
    }
    zoomAnimation(dish, newPosition) {
        const oldPos = dish.position.clone();
        const newPos = newPosition;
        if (Viewer.controls.zController)
            return;
        new Tween({ alpha: 0 }).to({ alpha: 1 }, 1000)
            .onUpdate((alpha) => {
            const currentPos = oldPos.clone().lerp(newPos, alpha);
            dish.position.copy(currentPos);
        })
            .start();
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
